import React, { useState, useRef, useEffect } from "react";
import {
  Container,
  Box,
  Paper,
  Typography,
  Button,
  TextField,
  IconButton,
  Snackbar,
  Alert,
  Stack,
  Divider,
  Tooltip,
  Fade,
  InputAdornment,
  Chip,
  Avatar,
  Badge,
  CircularProgress,
  alpha,
  Zoom,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  Drawer,
  Breadcrumbs,
  Link,
  Backdrop,
  tooltipClasses,
} from "@mui/material";
import Poetlogopen from "../static/POET_Logo_Pen.png"
import Grid from "@mui/material/Unstable_Grid2";
import {
  ContentCopy,
  Download,
  Save,
  Fullscreen,
  FullscreenExit,
  LinkedIn,
  Twitter,
  Instagram,
  Google,
  SmartToy,
  History,
  Search,
  Campaign,
  AdsClick,
  Bolt,
  TrendingUp,
  Psychology,
  AutoAwesome,
  Palette,
  Refresh,
  CheckCircle,
  RocketLaunch,
  Lightbulb,
  FlashOn,
  Style,
  Grade,
  Close,
  Delete,
  Visibility,
  AutoStories,
  ChevronRight,
  Home,
  AutoFixHigh,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import newBlogService from "../services/new_blogsServices";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link as RouterLink, useHistory } from "react-router-dom";



const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
    PopperProps={{
      modifiers: [
        {
          name: "zIndex",
          enabled: true,
          phase: "write",
          fn: ({ state }) => {
            state.styles.popper.zIndex = 99999;
          },
        },
      ],
    }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor:
      theme.palette.mode === "light"
        ? theme.palette.common.white
        : theme.palette.grey[900],
    color:
      theme.palette.mode === "light"
        ? theme.palette.primary.main
        : theme.palette.common.white,
    boxShadow: theme.shadows[6],
    fontSize: 12,
    fontWeight: 500,
    borderRadius: 10,
    padding: "8px 14px",
    backdropFilter: "blur(6px)",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color:
      theme.palette.mode === "light"
        ? theme.palette.common.white
        : theme.palette.grey[900],
  },
}));

const toolColors = {
  linkedin: {
    main: "#0A66C2",
    light: "#E8F4FD",
    gradient: "linear-gradient(135deg, #0A66C2 0%, #4DABF7 100%)",
  },
  twitter: {
    main: "#1DA1F2",
    light: "#E8F6FE",
    gradient: "linear-gradient(135deg, #1DA1F2 0%, #68C9FF 100%)",
  },
  instagram: {
    main: "#E4405F",
    light: "#FEF0F3",
    gradient: "linear-gradient(135deg, #E4405F 0%, #FF7A95 100%)",
  },
  google: {
    main: "#4285F4",
    light: "#E8F0FE",
    gradient: "linear-gradient(135deg, #4285F4 0%, #7BAAF9 100%)",
  },
};

const AIAdvertisingTools = () => {
  const [activeTool, setActiveTool] = useState(0);
  const [formData, setFormData] = useState({
    linkedin: {
      productName: "",
      productDescription: "",
      targetAudience: "",
    },
    twitter: {
      productDescription: "",
      campaignGoal: "",
      targetAudience: "",
    },
    instagram: {
      productDescription: "",
      copyCount: 1,
    },
    google: {
      focusKeyword: "",
      advertisingGoal: "",
    },
  });
  const [generatedContent, setGeneratedContent] = useState("");
  const [formattedContent, setFormattedContent] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [saved, setSaved] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [copied, setCopied] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [fullscreenDialogOpen, setFullscreenDialogOpen] = useState(false);
  const [savedContent, setSavedContent] = useState([]);
  const [savedContentDrawerOpen, setSavedContentDrawerOpen] = useState(false);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [selectedContent, setSelectedContent] = useState(null);
  const history = useHistory();

  const handleBreadcrumbClick = (event, path) => {
    event.preventDefault();
    window.location.href = "/docTags";
    // history.push(path);
  };
  const contentBoxRef = useRef(null);
  ;
  const tools = [
    {
      id: "linkedin",
      name: "LinkedIn ADs",
      icon: <LinkedIn sx={{ fontSize: 28 }} />,
      color: toolColors.linkedin,
      description: "Professional B2B ad copies",
      questions: [
        {
          id: "productName",
          label: "Product/Brand Name",
          placeholder: "Enter your product or brand name",
          icon: <Grade />,
        },
        {
          id: "productDescription",
          label: "Product/Service Description",
          placeholder: "Describe your product/service",
          multiline: true,
          rows: 3,
          icon: <Style />,
        },
        {
          id: "targetAudience",
          label: "Target Audience",
          placeholder: "Who is your target audience?",
          multiline: true,
          rows: 2,
          icon: <Psychology />,
        },
      ],
    },
    {
      id: "twitter",
      name: "Twitter ADs",
      icon: <Twitter sx={{ fontSize: 28 }} />,
      color: toolColors.twitter,
      description: "Engaging social media content",
      questions: [
        {
          id: "productDescription",
          label: "Product/Service Description",
          placeholder: "Briefly describe your product, services, or business",
          multiline: true,
          rows: 3,
          icon: <FlashOn />,
        },
        {
          id: "campaignGoal",
          label: "Campaign Goal",
          placeholder: "What do you want to achieve with this Twitter ad?",
          multiline: true,
          rows: 2,
          icon: <TrendingUp />,
        },
        {
          id: "targetAudience",
          label: "Target Audience (Optional)",
          placeholder: "Who is your target audience?",
          multiline: true,
          rows: 2,
          optional: true,
          icon: <Psychology />,
        },
      ],
    },
    {
      id: "instagram",
      name: "Instagram AD Copy",
      icon: <Instagram sx={{ fontSize: 28 }} />,
      color: toolColors.instagram,
      description: "Visual platform ad content",
      questions: [
        {
          id: "productDescription",
          label: "Product/Service Description",
          placeholder: "Describe your product/service",
          multiline: true,
          rows: 4,
          icon: <Palette />,
        },
        {
          id: "copyCount",
          label: "Number of Ad Copies",
          placeholder: "Enter number (1-10)",
          type: "number",
          inputProps: { min: 1, max: 10 },
          icon: <AutoAwesome />,
        },
      ],
    },
    {
      id: "google",
      name: "Google Ad Copy",
      icon: <Google sx={{ fontSize: 28 }} />,
      color: toolColors.google,
      description: "Search engine ad copies",
      questions: [
        {
          id: "focusKeyword",
          label: "Focus Keyword",
          placeholder: "Enter your focus keyword",
          icon: <Search />,
        },
        {
          id: "advertisingGoal",
          label: "Advertising Goal",
          placeholder: "What is the advertising goal of the ad?",
          multiline: true,
          rows: 3,
          icon: <RocketLaunch />,
        },
      ],
    },
  ]

  const formatGeneratedContent = (content) => {
    if (!content) return null;

    const lines = content.split("\n");
    const formattedLines = [];

    let currentSection = null;

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();

      if (!line) {
        formattedLines.push(<br key={`br-${i}`} />);
        continue;
      }

      if (
        line.endsWith(":") ||
        line.toLowerCase().includes("ad ") ||
        line.toLowerCase().includes("title:") ||
        line.toLowerCase().includes("headline:") ||
        (line.toLowerCase().includes("option") &&
          line.toLowerCase().includes(":")) ||
        /^[A-Z][a-z]+(?: [A-Z][a-z]+)*:$/.test(line)
      ) {
        const emojiMatch = line.match(
          /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}]/gu,
        );
        const emojis = emojiMatch ? emojiMatch.join(" ") : "";
        const textWithoutEmojis = line
          .replace(
            /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}]/gu,
            "",
          )
          .trim();

        formattedLines.push(
          <Box key={`title-${i}`} sx={{ mt: i > 0 ? 2 : 0, mb: 1 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: tools[activeTool].color.main,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              {emojis && <span>{emojis}</span>}
              <span>{textWithoutEmojis}</span>
            </Typography>
          </Box>,
        );

        currentSection = textWithoutEmojis;
      } else if (
        line.startsWith("-") ||
        line.startsWith("•") ||
        line.startsWith("*") ||
        /^\d+\./.test(line)
      ) {
        const emojiMatch = line.match(
          /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}]/gu,
        );
        const emojis = emojiMatch ? emojiMatch.join(" ") : "";
        let text = line;

        text = text.replace(/^[-•*]\s*/, "").replace(/^\d+\.\s*/, "");

        formattedLines.push(
          <Box
            key={`list-${i}`}
            sx={{ display: "flex", alignItems: "flex-start", mb: 0.5 }}
          >
            <Typography
              component="span"
              sx={{ mr: 1, color: tools[activeTool].color.main }}
            >
              •
            </Typography>
            <Typography component="span" sx={{ flex: 1 }}>
              {emojis && <span style={{ marginRight: 4 }}>{emojis}</span>}
              {formatBoldText(text)}
            </Typography>
          </Box>,
        );
      } else if (line.includes("**") || line.includes("__")) {
        formattedLines.push(
          <Typography key={`bold-${i}`} paragraph sx={{ mb: 1.5 }}>
            {formatBoldText(line)}
          </Typography>,
        );
      } else {
        const emojiMatch = line.match(
          /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}]/gu,
        );
        const emojis = emojiMatch ? emojiMatch.join(" ") : "";
        const textWithoutEmojis = line
          .replace(
            /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}]/gu,
            "",
          )
          .trim();

        formattedLines.push(
          <Typography
            key={`para-${i}`}
            paragraph
            sx={{ mb: 1.5, display: "flex", alignItems: "flex-start", gap: 1 }}
          >
            {emojis && (
              <span style={{ fontSize: "1.2em", lineHeight: 1 }}>{emojis}</span>
            )}
            <span>{formatBoldText(textWithoutEmojis)}</span>
          </Typography>,
        );
      }
    }

    return formattedLines;
  };

  const formatBoldText = (text) => {
    if (!text) return text;

    const parts = [];
    let currentIndex = 0;

    const boldRegex = /(\*\*|__)(.*?)\1/g;
    let match;

    while ((match = boldRegex.exec(text)) !== null) {
      if (match.index > currentIndex) {
        parts.push(text.substring(currentIndex, match.index));
      }

      parts.push(
        <Box
          component="span"
          key={`bold-${currentIndex}`}
          sx={{
            fontWeight: 700,
            color: tools[activeTool].color.main,
            backgroundColor: alpha(tools[activeTool].color.main, 0.08),
            px: 0.5,
            borderRadius: 1,
          }}
        >
          {match[2]}
        </Box>,
      );

      currentIndex = match.index + match[0].length;
    }

    if (currentIndex < text.length) {
      parts.push(text.substring(currentIndex));
    }

    if (parts.length === 0) {
      return text;
    }

    return parts;
  };

  useEffect(() => {
    if (generatedContent) {
      const formatted = formatGeneratedContent(generatedContent);
      setFormattedContent(formatted);
    } else {
      setFormattedContent(null);
    }
  }, [generatedContent, activeTool]);

  const currentColor = tools[activeTool].color;

  const handleToolChange = (event, newValue) => {
    setActiveTool(newValue);
    setGeneratedContent("");
    setFormattedContent(null);
    setSaved(false);
  };

  const handleInputChange = (toolId, fieldId, value) => {
    setFormData((prev) => ({
      ...prev,
      [toolId]: {
        ...prev[toolId],
        [fieldId]: value,
      },
    }));
    setSaved(false);
  };

  const startLoading = () => {
    setIsLoading(true);
    setIsGenerating(true);
  };

  const stopLoading = () => {
    setIsLoading(false);
    setIsGenerating(false);
  };

  const generateLinkedInAdsFromAPI = async () => {
    const toolData = formData.linkedin;

    if (
      !toolData.productName ||
      !toolData.productDescription ||
      !toolData.targetAudience
    ) {
      setSnackbar({
        open: true,
        message: "Please fill all LinkedIn fields!",
        severity: "warning",
      });
      return;
    }

    try {
      startLoading();

      const payload = {
        product_name: toolData.productName,
        product_description: toolData.productDescription,
        target_audience: toolData.targetAudience,
        tone: "Professional",
      };

      const res = await newBlogService.generateLinkedInAds(payload);

      if (res.status === 200) {
        setGeneratedContent(res.data.ads);
        setSnackbar({
          open: true,
          message: "LinkedIn Ads generated successfully! 🚀",
          severity: "success",
        });
      }
    } catch (err) {
      console.error(err);
      setSnackbar({
        open: true,
        message: "Failed to generate LinkedIn ads",
        severity: "error",
      });
    } finally {
      stopLoading();
    }
  };

  const generateTwitterContent = async () => {
    const toolData = formData.twitter;

    if (!toolData.productDescription || !toolData.campaignGoal) {
      setSnackbar({
        open: true,
        message: "Please fill required Twitter fields!",
        severity: "warning",
      });
      return;
    }

    try {
      startLoading();

      const payload = {
        product_description: toolData.productDescription,
        campaign_goal: toolData.campaignGoal,
        target_audience: toolData.targetAudience || "",
        tone: "Professional",
      };

      const res = await newBlogService.generateTwitterAds(payload);

      if (res.status === 200) {
        setGeneratedContent(res.data.content);
        setSnackbar({
          open: true,
          message: "Twitter Ads generated successfully! 🚀",
          severity: "success",
        });
      }
    } catch (err) {
      console.error(err);
      setSnackbar({
        open: true,
        message: "Failed to generate Twitter ads",
        severity: "error",
      });
    } finally {
      stopLoading();
    }
  };

  const generateInstagramContent = async () => {
    const toolData = formData.instagram;

    if (!toolData.productDescription) {
      setSnackbar({
        open: true,
        message: "Please fill Instagram product description!",
        severity: "warning",
      });
      return;
    }

    try {
      startLoading();

      const payload = {
        product_description: toolData.productDescription,
        number_of_ads: parseInt(toolData.copyCount) || 1,
        tone: "Creative",
      };

      const res = await newBlogService.generateInstagramAds(payload);

      if (res.status === 200) {
        setGeneratedContent(res.data.content);
        setSnackbar({
          open: true,
          message: "Instagram Ads generated successfully! 🚀",
          severity: "success",
        });
      }
    } catch (err) {
      console.error(err);
      setSnackbar({
        open: true,
        message: "Failed to generate Instagram ads",
        severity: "error",
      });
    } finally {
      stopLoading();
    }
  };

  const generateGoogleContent = async () => {
    const toolData = formData.google;

    if (!toolData.focusKeyword || !toolData.advertisingGoal) {
      setSnackbar({
        open: true,
        message: "Please fill all Google Ad fields!",
        severity: "warning",
      });
      return;
    }

    try {
      startLoading();

      const payload = {
        focus_keyword: toolData.focusKeyword,
        advertising_goal: toolData.advertisingGoal,
        tone: "Professional",
      };

      const res = await newBlogService.generateGoogleAds(payload);

      if (res.status === 200) {
        setGeneratedContent(res.data.content);
        setSnackbar({
          open: true,
          message: "Google Ads generated successfully! 🚀",
          severity: "success",
        });
      }
    } catch (err) {
      console.error(err);
      setSnackbar({
        open: true,
        message: "Failed to generate Google ads",
        severity: "error",
      });
    } finally {
      stopLoading();
    }
  };

  const generateContent = () => {
    const currentTool = tools[activeTool];

    switch (currentTool.id) {
      case "linkedin":
        generateLinkedInAdsFromAPI();
        break;

      case "twitter":
        generateTwitterContent();
        break;

      case "instagram":
        generateInstagramContent();
        break;

      case "google":
        generateGoogleContent();
        break;

      default:
        break;
    }
  };

  const handleSave = () => {
    if (!generatedContent) {
      setSnackbar({
        open: true,
        message: "No content to save! Please generate content first.",
        severity: "warning",
      });
      return;
    }

    const saveItem = {
      id: Date.now(),
      content: generatedContent,
      formattedContent: formattedContent,
      tool: tools[activeTool],
      timestamp: new Date().toLocaleString(),
      title: `${tools[activeTool].name} - ${new Date().toLocaleTimeString()}`,
    };

    setSavedContent((prev) => [saveItem, ...prev]);
    setSaved(true);
    setSnackbar({
      open: true,
      message: "Content saved successfully! 💾",
      severity: "success",
    });

    setTimeout(() => {
      setSaved(false);
    }, 2000);
  };

  const handleViewSavedContent = (content) => {
    setGeneratedContent(content.content);
    setFormattedContent(
      content.formattedContent || formatGeneratedContent(content.content),
    );
    setFullscreenDialogOpen(true);
  };

  const handleViewInPopup = (content) => {
    setSelectedContent(content);
    setViewDialogOpen(true);
  };

  const handleDeleteSavedContent = (id) => {
    setSavedContent((prev) => prev.filter((item) => item.id !== id));
    setSnackbar({
      open: true,
      message: "Content deleted successfully! 🗑️",
      severity: "info",
    });
  };

  const handleCopy = () => {
    navigator.clipboard
      .writeText(generatedContent)
      .then(() => {
        setCopied(true);
        setSnackbar({
          open: true,
          message: "Content copied to clipboard! 📋",
          severity: "success",
        });

        setTimeout(() => {
          setCopied(false);
        }, 2000);
      })
      .catch((err) => {
        setSnackbar({
          open: true,
          message: "Failed to copy content",
          severity: "error",
        });
      });
  };

  const handleDownload = () => {
    if (!generatedContent) {
      setSnackbar({
        open: true,
        message: "No content to download! Please generate content first.",
        severity: "warning",
      });
      return;
    }

    setDownloadProgress(0);
    const interval = setInterval(() => {
      setDownloadProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);

          const element = document.createElement("a");
          const file = new Blob([generatedContent], { type: "text/plain" });
          element.href = URL.createObjectURL(file);
          element.download = `ad-copy-${tools[activeTool].id}-${new Date().toISOString().slice(0, 10)}.txt`;
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);

          setSnackbar({
            open: true,
            message: "Content downloaded! 📥",
            severity: "success",
          });

          return 100;
        }
        return prev + 20;
      });
    }, 100);
  };

  const toggleFullscreen = () => {
    if (!generatedContent) {
      setSnackbar({
        open: true,
        message:
          "No content to view in fullscreen! Please generate content first.",
        severity: "warning",
      });
      return;
    }
    setFullscreenDialogOpen(true);
  };

  const handleCloseFullscreen = () => {
    setFullscreenDialogOpen(false);
  };

  const handleOpenSavedContent = () => {
    setSavedContentDrawerOpen(true);
  };

  const handleCloseSavedContent = () => {
    setSavedContentDrawerOpen(false);
  };

  const handleReset = () => {
    setFormData({
      linkedin: { productName: "", productDescription: "", targetAudience: "" },
      twitter: { productDescription: "", campaignGoal: "", targetAudience: "" },
      instagram: { productDescription: "", copyCount: 1 },
      google: { focusKeyword: "", advertisingGoal: "" },
    });
    setGeneratedContent("");
    setFormattedContent(null);
    setSnackbar({
      open: true,
      message: "Form reset successfully!",
      severity: "info",
    });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <>
      {/* Modern Full-screen Loading Overlay */}
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 999,
          backgroundColor: "rgba(0, 0, 0, 0.85)",
          backdropFilter: "blur(10px)",
        }}
        open={isLoading}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          {/* Animated Gradient Background */}
          <Box
            sx={{
              position: "relative",
              width: 200,
              height: 200,
              mb: 4,
              "&::before": {
                content: '""',
                position: "absolute",
                top: -20,
                left: -20,
                right: -20,
                bottom: -20,
                background: currentColor.gradient,
                borderRadius: "50%",
                animation: "pulse 2s infinite",
                "@keyframes pulse": {
                  "0%": {
                    transform: "scale(1)",
                    opacity: 0.7,
                  },
                  "50%": {
                    transform: "scale(1.1)",
                    opacity: 0.4,
                  },
                  "100%": {
                    transform: "scale(1)",
                    opacity: 0.7,
                  },
                },
              },
            }}
          >
            <CircularProgress
              size={200}
              thickness={1.5}
              sx={{
                color: "white",
                position: "relative",
                zIndex: 1,
                "& .MuiCircularProgress-circle": {
                  animation: "rotate 3s linear infinite",
                  "@keyframes rotate": {
                    "0%": {
                      transform: "rotate(0deg)",
                    },
                    "100%": {
                      transform: "rotate(360deg)",
                    },
                  },
                },
              }}
            />
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <SmartToy sx={{ fontSize: 48, color: "white", mb: 1 }} />
              <Typography
                variant="caption"
                sx={{ color: "white", fontWeight: 600 }}
              >
                AI is crafting your ads...
              </Typography>
            </Box>
          </Box>

          {/* Loading Text with Progress */}
          <Box sx={{ maxWidth: 500, mb: 4 }}>
            <Typography
              variant="h5"
              fontWeight="700"
              sx={{ mb: 2, color: "white" }}
            >
              Generating {tools[activeTool].name}
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: "rgba(255,255,255,0.8)", mb: 3 }}
            >
              Our AI is analyzing your inputs and creating high-converting ad
              copies...
            </Typography>

            {/* Progress Steps */}
            <Grid container spacing={2} justifyContent="center">
              {[
                "Analyzing Input",
                "Generating Ideas",
                "Crafting Copy",
                "Optimizing",
              ].map((step, index) => (
                <Grid key={step}>
                  <Chip
                    label={step}
                    icon={
                      index === 0 ? (
                        <AutoAwesome />
                      ) : index === 1 ? (
                        <Lightbulb />
                      ) : index === 2 ? (
                        <Style />
                      ) : (
                        <TrendingUp />
                      )
                    }
                    sx={{
                      backgroundColor: "rgba(255,255,255,0.1)",
                      color: "white",
                      border: "1px solid rgba(255,255,255,0.2)",
                      animation: `fadeIn 0.5s ${index * 0.2}s both`,
                      "@keyframes fadeIn": {
                        from: { opacity: 0, transform: "translateY(10px)" },
                        to: { opacity: 1, transform: "translateY(0)" },
                      },
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Loading Animation with Dots */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {[0, 1, 2].map((dot) => (
              <Box
                key={dot}
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: "50%",
                  backgroundColor: currentColor.main,
                  animation: `bounce 1.4s infinite ${dot * 0.2}s`,
                  "@keyframes bounce": {
                    "0%, 80%, 100%": {
                      transform: "scale(0)",
                    },
                    "40%": {
                      transform: "scale(1)",
                    },
                  },
                }}
              />
            ))}
          </Box>
        </Box>
      </Backdrop>

      <Container maxWidth="xl" sx={{ py: 4, px: { xs: 2, sm: 3 } }}>
        {/* Modern Breadcrumb */}
        <Box sx={{ mb: 4 }}>
          {/* <Paper
            elevation={0}
            sx={{
              p: 2.5,
              borderRadius: 3,
              backgroundColor: "background.paper",
              border: "1px solid",
              borderColor: "divider",
              transition: "all 0.3s ease",
              "&:hover": {
                boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
              },
            }}
          > */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                px: 1,
                textShadow: "0 0 10px rgba(192,144,255,0.6)",
              }}
            >
              <Box
                sx={{
                  bgcolor: "white",
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 32,
                  height: 32,
                  mr: 2,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                }}
              >
                <img
                  alt="logo"
                  src={Poetlogopen}
                  style={{
                    height: "28px",
                    width: "28px",
                    objectFit: "contain",
                    bgcolor: 'white',
                    // filter: "drop-shadow(0 0 7px rgba(93, 0, 255, 0.65))",
                    filter: "drop-shadow(0 0 7px rgba(163, 163, 164, 0.65))",
                  }}
                />
              </Box>
              <Breadcrumbs
                separator={
                  <NavigateNextIcon fontSize="small" sx={{ color: "#667eea" }} />
                }
                aria-label="breadcrumb"
              >
                {/* First breadcrumb item */}
                <Box
                  component={RouterLink}
                  to="/docTags"
                  onClick={(e) => handleBreadcrumbClick(e, "/docTags")}
                  sx={{
                    textDecoration: "none",
                    display: "flex",
                    alignItems: "center",
                    color: "#667eea",
                    fontWeight: 500,
                    fontSize: "0.95rem",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    backgroundColor: "rgba(102, 126, 234, 0.08)",
                    whiteSpace: "nowrap",
                    flexShrink: 0,
                    transition: "all 0.2s ease",
                    "&:hover": {
                      backgroundColor: "rgba(102, 126, 234, 0.12)",
                      color: "#764ba2",
                      transform: "translateY(-1px)",
                    },
                  }}
                >
                  <AutoFixHigh sx={{ fontSize: 20, mr: 1 }} />
                  MultiTool AI
                </Box>

                {/* Current page */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    backgroundColor: "rgba(102, 126, 234, 0.08)",
                  }}
                >
                  <AutoAwesome sx={{ fontSize: 20, color: "#667eea", mr: 1 }} />
                  <Typography
                    sx={{
                      color: "#1a1a1a",
                      fontWeight: 600,
                      fontSize: "0.95rem",
                    }}
                  >
                    AI Advertising Tool
                  </Typography>
                </Box>
              </Breadcrumbs>
              </Box>
          {/* </Paper> */}
        </Box>
        <Box sx={{ mb: 2, mt:-5, textAlign: "center" }}>
          <Box
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              display: "inline-block",
              mb: 2,
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              spacing={2}
            >
              {/* <SmartToy sx={{ fontSize: 15 }} /> */}
              <Typography variant="h4" component="h3" fontWeight="600">
                <b> AI Advertising Tools</b>
              </Typography>
            </Stack>
          </Box>
          <Typography
            variant="h6"
            color="text.secondary"
            sx={{
              maxWidth: 300,
              mx: "auto",
              fontWeight: 80,
              background: "linear-gradient(45deg, #6a11cb 0%, #2575fc 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Precision-Crafted Ads. Powered by AI.
          </Typography>

          <Box
            sx={{
              mt: 1,
              display: "flex",
              justifyContent: "center",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <Chip
              icon={<Bolt />}
              label="AI-Powered"
              color="primary"
              variant="outlined"
            />
            <Chip
              icon={<TrendingUp />}
              label="High Converting"
              color="success"
              variant="outlined"
            />
            <Chip
              icon={<AutoAwesome />}
              label="Multiple Platforms"
              color="warning"
              variant="outlined"
            />
            <Chip
              icon={<FlashOn />}
              label="Instant Results"
              color="info"
              variant="outlined"
            />
          </Box>
        </Box>

        <Grid container spacing={3}>
          {/* Left Panel - Tool Selection & Questions */}
          <Grid xs={12} md={5}>
            <Paper
              elevation={8}
              sx={{
                p: 3,
                height: "100%",
                borderRadius: 4,
                background: "linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%)",
                border: "1px solid rgba(255,255,255,0.3)",
                boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                backdropFilter: "blur(10px)",
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ mb: 3 }}
              >
                <Typography
                  variant="h5"
                  fontWeight="800"
                  sx={{ display: "flex", alignItems: "center", gap: 1 }}
                >
                  <Campaign sx={{ color: currentColor.main }} />
                  <Box
                    component="span"
                    sx={{
                      background: currentColor.gradient,
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Ad Platform
                  </Box>
                </Typography>
                <Chip
                  icon={<Lightbulb />}
                  label="AI Powered"
                  sx={{
                    background: currentColor.gradient,
                    color: "white",
                    fontWeight: 600,
                  }}
                />
              </Stack>

              <Grid container spacing={2} sx={{ mb: 4 }}>
                {tools.map((tool, index) => (
                  <Grid xs={6} key={tool.id}>
                    <Paper
                      onClick={() => handleToolChange(null, index)}
                      sx={{
                        p: 2,
                        borderRadius: 3,
                        cursor: "pointer",
                        transition: "all 0.3s",
                        border:
                          activeTool === index
                            ? `3px solid ${tool.color.main}`
                            : "2px solid transparent",
                        background:
                          activeTool === index
                            ? `linear-gradient(135deg, ${alpha(tool.color.main, 0.1)} 0%, ${alpha(tool.color.main, 0.05)} 100%)`
                            : "white",
                        boxShadow:
                          activeTool === index
                            ? `0 10px 30px ${alpha(tool.color.main, 0.2)}`
                            : "0 5px 15px rgba(0,0,0,0.05)",
                        "&:hover": {
                          transform: "translateY(-5px)",
                          boxShadow: `0 15px 35px ${alpha(tool.color.main, 0.3)}`,
                        },
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <Avatar
                        sx={{
                          bgcolor: tool.color.main,
                          width: 56,
                          height: 56,
                          mb: 1.5,
                          boxShadow: `0 8px 20px ${alpha(tool.color.main, 0.4)}`,
                        }}
                      >
                        {React.cloneElement(tool.icon, {
                          sx: { color: "white" },
                        })}
                      </Avatar>
                      <Typography variant="subtitle1" fontWeight="700">
                        {tool.name}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {tool.description}
                      </Typography>
                    </Paper>
                  </Grid>
                ))}
              </Grid>

              <Box>
                <Typography
                  variant="h6"
                  fontWeight="700"
                  sx={{ mb: 3, display: "flex", alignItems: "center", gap: 1 }}
                >
                  <AdsClick sx={{ color: currentColor.main }} />
                  <Box
                    component="span"
                    sx={{
                      background: currentColor.gradient,
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    {tools[activeTool].name} Details
                  </Box>
                </Typography>

                {tools[activeTool].questions.map((question) => (
                  <TextField
                    key={question.id}
                    fullWidth
                    label={
                      <Stack direction="row" alignItems="center" spacing={1}>
                        {question.icon}
                        <span>{question.label}</span>
                      </Stack>
                    }
                    variant="filled"
                    value={formData[tools[activeTool].id][question.id]}
                    onChange={(e) =>
                      handleInputChange(
                        tools[activeTool].id,
                        question.id,
                        e.target.value,
                      )
                    }
                    placeholder={question.placeholder}
                    multiline={question.multiline || false}
                    rows={question.rows || 1}
                    type={question.type || "text"}
                    InputProps={
                      question.inputProps
                        ? { inputProps: question.inputProps }
                        : {}
                    }
                    sx={{
                      mb: 3,
                      "& .MuiFilledInput-root": {
                        borderRadius: 3,
                        transition: "all 0.2s",
                        background: "rgba(255,255,255,0.9)",
                        "&:hover": {
                          background: "white",
                          boxShadow: `0 8px 25px ${alpha(currentColor.main, 0.15)}`,
                        },
                        "&.Mui-focused": {
                          background: "white",
                          boxShadow: `0 8px 25px ${alpha(currentColor.main, 0.2)}`,
                        },
                      },
                    }}
                  />
                ))}

                <Stack direction="row" spacing={2}>
                  <Button
                    fullWidth
                    variant="contained"
                    size="large"
                    onClick={generateContent}
                    disabled={isGenerating}
                    startIcon={
                      isGenerating ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        <SmartToy />
                      )
                    }
                    sx={{
                      py: 1.8,
                      borderRadius: 3,
                      fontWeight: 800,
                      fontSize: "1rem",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      background: currentColor.gradient,
                      boxShadow: `0 10px 30px ${alpha(currentColor.main, 0.4)}`,
                      "&:hover": {
                        boxShadow: `0 15px 40px ${alpha(currentColor.main, 0.6)}`,
                        transform: "translateY(-3px)",
                      },
                      transition: "all 0.3s",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    {isGenerating ? "Generating..." : "Generate Ad Copy"}
                  </Button>

                  <Button
                    variant="outlined"
                    size="large"
                    onClick={handleReset}
                    startIcon={<Refresh />}
                    sx={{
                      borderRadius: 3,
                      fontWeight: 600,
                      borderWidth: 2,
                      "&:hover": {
                        borderWidth: 2,
                        transform: "rotate(-15deg)",
                      },
                      transition: "all 0.3s",
                    }}
                  >
                    Reset
                  </Button>
                </Stack>
              </Box>
            </Paper>
          </Grid>

          {/* Right Panel - Generated Content */}
          <Grid xs={12} md={7}>
            <Paper
              elevation={8}
              sx={{
                p: 0,
                height: "100%",
                borderRadius: 4,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                boxShadow: `0 25px 50px ${alpha(currentColor.main, 0.15)}`,
                border: "1px solid rgba(255,255,255,0.3)",
              }}
            >
              <Box
                sx={{
                  p: 3,
                  background: currentColor.gradient,
                  color: "white",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Avatar
                    sx={{
                      bgcolor: currentColor.main,
                      width: 48,
                      height: 48,
                      color: "white",
                    }}
                  >
                    {React.cloneElement(tools[activeTool].icon, {
                      sx: { color: "white" },
                    })}
                  </Avatar>
                  <Box>
                    <Typography variant="h5" fontWeight="800">
                      {tools[activeTool].name} - Generated Content
                    </Typography>
                    <Typography variant="caption" sx={{ opacity: 0.9 }}>
                      AI-powered advertising copy
                    </Typography>
                  </Box>
                </Box>

                <Stack direction="row" spacing={1}>
                  <CustomTooltip title="View Saved Content">
                    <IconButton
                      onClick={handleOpenSavedContent}
                      sx={{
                        color: "white",
                        bgcolor: "rgba(255,255,255,0.2)",
                        transition: "all 0.3s",
                        "&:hover": {
                          bgcolor: "rgba(255,255,255,0.3)",
                          transform: "scale(1.1)",
                        },
                      }}
                    >
                      <History />
                    </IconButton>
                  </CustomTooltip>

                  <CustomTooltip title={saved ? "Saved ✓" : "Save Content"}>
                    <IconButton
                      onClick={handleSave}
                      disabled={!generatedContent}
                      sx={{
                        color: "white",
                        bgcolor: saved
                          ? "rgba(255,255,255,0.3)"
                          : "rgba(255,255,255,0.2)",
                        transition: "all 0.3s",
                        "&:hover": {
                          bgcolor: "rgba(255,255,255,0.3)",
                          transform: "scale(1.1)",
                        },
                      }}
                    >
                      {saved ? <CheckCircle /> : <Save />}
                    </IconButton>
                  </CustomTooltip>

                  <CustomTooltip title={copied ? "Copied ✓" : "Copy to Clipboard"}>
                    <IconButton
                      onClick={handleCopy}
                      disabled={!generatedContent}
                      sx={{
                        color: "white",
                        bgcolor: copied
                          ? "rgba(255,255,255,0.3)"
                          : "rgba(255,255,255,0.2)",
                        transition: "all 0.3s",
                        "&:hover": {
                          bgcolor: "rgba(255,255,255,0.3)",
                          transform: "scale(1.1)",
                        },
                      }}
                    >
                      {copied ? <CheckCircle /> : <ContentCopy />}
                    </IconButton>
                  </CustomTooltip>

                  <CustomTooltip title="Download">
                    <Box sx={{ position: "relative" }}>
                      <IconButton
                        onClick={handleDownload}
                        disabled={!generatedContent}
                        sx={{
                          color: "white",
                          bgcolor: "rgba(255,255,255,0.2)",
                          transition: "all 0.3s",
                          "&:hover": {
                            bgcolor: "rgba(255,255,255,0.3)",
                            transform: "scale(1.1)",
                          },
                        }}
                      >
                        {downloadProgress > 0 && downloadProgress < 100 ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : (
                          <Download />
                        )}
                      </IconButton>
                    </Box>
                  </CustomTooltip>

                  <CustomTooltip title="View Fullscreen">
                    <IconButton
                      onClick={toggleFullscreen}
                      disabled={!generatedContent}
                      sx={{
                        color: "white",
                        bgcolor: "rgba(255,255,255,0.2)",
                        transition: "all 0.3s",
                        "&:hover": {
                          bgcolor: "rgba(255,255,255,0.3)",
                          transform: "scale(1.1)",
                        },
                      }}
                    >
                      <Fullscreen />
                    </IconButton>
                  </CustomTooltip>
                </Stack>
              </Box>

              {/* Content Box */}
              <Box
                ref={contentBoxRef}
                sx={{
                  p: 4,
                  flexGrow: 1,
                  overflow: "auto",
                  bgcolor: "background.default",
                  minHeight: 400,
                  maxHeight: 600,
                  background:
                    "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {generatedContent ? (
                  <Fade in={true}>
                    <Paper
                      elevation={2}
                      sx={{
                        p: 4,
                        borderRadius: 3,
                        bgcolor: "white",
                        border: `1px solid ${alpha(currentColor.main, 0.1)}`,
                        fontFamily:
                          "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
                        lineHeight: 1.6,
                        boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
                      }}
                    >
                      {formattedContent}
                    </Paper>
                  </Fade>
                ) : (
                  <Box
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "text.secondary",
                      textAlign: "center",
                      p: 5,
                    }}
                  >
                    <Box
                      sx={{
                        width: 120,
                        height: 120,
                        borderRadius: "50%",
                        background: currentColor.gradient,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 4,
                        boxShadow: `0 20px 40px ${alpha(currentColor.main, 0.3)}`,
                      }}
                    >
                      <SmartToy sx={{ fontSize: 60, color: "white" }} />
                    </Box>
                    <Typography variant="h5" fontWeight="700" sx={{ mb: 2 }}>
                      Your AI-generated ad copy will appear here
                    </Typography>
                    <Typography variant="body1" sx={{ maxWidth: 500, mb: 4 }}>
                      Fill out the form and click "Generate Ad Copy" to create
                      compelling, high-converting ad content for{" "}
                      {tools[activeTool].name}.
                    </Typography>
                    <Chip
                      icon={<AutoAwesome />}
                      label="Powered by Advanced AI"
                      sx={{
                        background: currentColor.gradient,
                        color: "white",
                        fontWeight: 600,
                        px: 2,
                        py: 1,
                      }}
                    />
                  </Box>
                )}
              </Box>

              {/* Content Footer */}
              <Box
                sx={{
                  p: 2.5,
                  bgcolor: alpha(currentColor.main, 0.08),
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderTop: `1px solid ${alpha(currentColor.main, 0.1)}`,
                }}
              >
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Badge
                    color="primary"
                    variant="dot"
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                  >
                    <Avatar
                      sx={{ width: 32, height: 32, bgcolor: currentColor.main }}
                    >
                      <AutoAwesome sx={{ fontSize: 16, color: "white" }} />
                    </Avatar>
                  </Badge>
                  <Box>
                    <Typography
                      variant="caption"
                      fontWeight="600"
                      color="text.secondary"
                    >
                      {generatedContent
                        ? `${generatedContent.length} characters generated`
                        : "Ready to generate"}
                    </Typography>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      display="block"
                    >
                      AI-powered •{" "}
                      {new Date().toLocaleDateString("en-US", {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </Typography>
                  </Box>
                </Stack>

                <Stack direction="row" spacing={1}>
                  <History fontSize="small" color="action" />
                  <Typography variant="caption" color="text.secondary">
                    Generated in {isGenerating ? "..." : "1.5s"}
                  </Typography>
                </Stack>
              </Box>
            </Paper>
          </Grid>
        </Grid>

        {/* Fullscreen Dialog */}
        <Dialog
          open={fullscreenDialogOpen}
          onClose={handleCloseFullscreen}
          fullScreen
          TransitionComponent={Zoom}
        >
          <Box
            sx={{
              p: 3,
              background: currentColor.gradient,
              color: "white",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Avatar
                sx={{
                  bgcolor: currentColor.main,
                  width: 48,
                  height: 48,
                  color: "white",
                }}
              >
                {React.cloneElement(tools[activeTool].icon, {
                  sx: { color: "white" },
                })}
              </Avatar>
              <Box>
                <Typography variant="h4" fontWeight="800">
                  {tools[activeTool].name} - Generated Content
                </Typography>
                <Typography variant="caption" sx={{ opacity: 0.9 }}>
                  Fullscreen View • AI-powered advertising copy
                </Typography>
              </Box>
            </Box>

            <Stack direction="row" spacing={1}>
              <CustomTooltip title="Copy to Clipboard">
                <IconButton
                  onClick={handleCopy}
                  sx={{
                    color: "white",
                    bgcolor: "rgba(255,255,255,0.2)",
                    transition: "all 0.3s",
                    "&:hover": {
                      bgcolor: "rgba(255,255,255,0.3)",
                      transform: "scale(1.1)",
                    },
                  }}
                >
                  <ContentCopy />
                </IconButton>
              </CustomTooltip>
              <CustomTooltip title="Close Fullscreen">
                <IconButton
                  onClick={handleCloseFullscreen}
                  sx={{
                    color: "white",
                    bgcolor: "rgba(255,255,255,0.2)",
                    transition: "all 0.3s",
                    "&:hover": {
                      bgcolor: "rgba(255,255,255,0.3)",
                      transform: "scale(1.1)",
                    },
                  }}
                >
                  <Close />
                </IconButton>
              </CustomTooltip>
            </Stack>
          </Box>

          <DialogContent sx={{ p: 0, bgcolor: "background.default" }}>
            <Box sx={{ p: 4, height: "calc(100vh - 120px)", overflow: "auto" }}>
              <Paper
                sx={{
                  p: 6,
                  borderRadius: 3,
                  bgcolor: "white",
                  border: `2px solid ${alpha(currentColor.main, 0.2)}`,
                  fontFamily:
                    "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
                }}
              >
                {formattedContent}
              </Paper>
            </Box>
          </DialogContent>

          <DialogActions
            sx={{
              p: 3,
              bgcolor: alpha(currentColor.main, 0.08),
              borderTop: `1px solid ${alpha(currentColor.main, 0.1)}`,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Typography variant="body2" color="text.secondary">
                {generatedContent.length} characters • Generated on{" "}
                {new Date().toLocaleString()}
              </Typography>
              <Stack direction="row" spacing={2}>
                <Button
                  variant="outlined"
                  onClick={handleCopy}
                  startIcon={<ContentCopy />}
                >
                  Copy
                </Button>
                <Button
                  variant="contained"
                  onClick={handleDownload}
                  sx={{ background: currentColor.gradient }}
                  startIcon={<Download />}
                >
                  Download
                </Button>
              </Stack>
            </Box>
          </DialogActions>
        </Dialog>

        {/* View Content Dialog (Popup) */}
        <Dialog
          open={viewDialogOpen}
          onClose={() => setViewDialogOpen(false)}
          maxWidth="md"
          fullWidth
          TransitionComponent={Zoom}
        >
          <DialogTitle sx={{ pb: 2 }}>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Avatar sx={{ bgcolor: selectedContent?.tool.color.main }}>
                {selectedContent &&
                  React.cloneElement(selectedContent.tool.icon, {
                    sx: { color: "white" },
                  })}
              </Avatar>
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="h6" fontWeight="700">
                  {selectedContent?.title}
                </Typography>
                <Stack
                  direction="row"
                  spacing={2}
                  alignItems="center"
                  sx={{ mt: 0.5 }}
                >
                  <Chip
                    label={selectedContent?.tool.name}
                    size="small"
                    sx={{
                      bgcolor: alpha(
                        selectedContent?.tool.color.main || "#000",
                        0.1,
                      ),
                      color: selectedContent?.tool.color.main,
                      fontWeight: 600,
                    }}
                  />
                  <Typography variant="caption" color="text.secondary">
                    {selectedContent?.timestamp}
                  </Typography>
                </Stack>
              </Box>
              <IconButton
                onClick={() => setViewDialogOpen(false)}
                sx={{
                  color: "text.secondary",
                  "&:hover": {
                    color: "text.primary",
                    backgroundColor: "rgba(0,0,0,0.04)",
                  },
                }}
              >
                <Close />
              </IconButton>
            </Stack>
          </DialogTitle>
          <DialogContent sx={{ pt: 2 }}>
            <Paper
              sx={{
                p: 3,
                borderRadius: 2,
                bgcolor: "grey.50",
                fontFamily:
                  "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
                maxHeight: "400px",
                overflow: "auto",
                border: `1px solid ${alpha(selectedContent?.tool.color.main || "#000", 0.1)}`,
              }}
            >
              {selectedContent?.formattedContent ||
                (selectedContent?.content &&
                  formatGeneratedContent(selectedContent.content))}
            </Paper>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 3, pt: 2 }}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              sx={{ width: "100%" }}
            >
              <Typography variant="body2" color="text.secondary">
                {selectedContent?.content.length} characters
              </Typography>
              <Stack direction="row" spacing={1}>
                <Button
                  onClick={() => setViewDialogOpen(false)}
                  startIcon={<Close />}
                  variant="outlined"
                  sx={{
                    color: "text.secondary",
                    borderColor: "divider",
                  }}
                >
                  Close
                </Button>
                <Button
                  onClick={() => {
                    if (selectedContent) {
                      navigator.clipboard.writeText(selectedContent.content);
                      setSnackbar({
                        open: true,
                        message: "Content copied to clipboard!",
                        severity: "success",
                      });
                      setViewDialogOpen(false);
                    }
                  }}
                  startIcon={<ContentCopy />}
                  variant="contained"
                  sx={{
                    background: selectedContent
                      ? selectedContent.tool.color.gradient
                      : "primary.main",
                  }}
                >
                  Copy
                </Button>
              </Stack>
            </Stack>
          </DialogActions>
        </Dialog>

        {/* Saved Content Drawer */}
        <Drawer
          anchor="right"
          open={savedContentDrawerOpen}
          onClose={handleCloseSavedContent}
          PaperProps={{
            sx: {
              width: { xs: "100%", sm: 500 },
              p: 3,
              borderRadius: "20px 0 0 20px",
              background: "linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%)",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            <Typography variant="h5" fontWeight="800">
              <Stack direction="row" alignItems="center" spacing={1}>
                <Save color="primary" />
                <span>Saved Content</span>
              </Stack>
            </Typography>
            <IconButton
              onClick={handleCloseSavedContent}
              sx={{
                color: "text.secondary",
                "&:hover": {
                  color: "text.primary",
                  backgroundColor: "rgba(0,0,0,0.04)",
                },
              }}
            >
              <Close />
            </IconButton>
          </Box>

          {savedContent.length === 0 ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "60vh",
                textAlign: "center",
                color: "text.secondary",
              }}
            >
              <Save sx={{ fontSize: 80, color: "action.disabled", mb: 2 }} />
              <Typography variant="h6" gutterBottom>
                No saved content yet
              </Typography>
              <Typography variant="body2">
                Generate content and click the save button to store it here
              </Typography>
            </Box>
          ) : (
            <List sx={{ width: "100%" }}>
              {savedContent.map((item) => (
                <ListItem
                  key={item.id}
                  sx={{
                    mb: 2,
                    borderRadius: 2,
                    bgcolor: alpha(item.tool.color.main, 0.05),
                    border: `1px solid ${alpha(item.tool.color.main, 0.1)}`,
                    "&:hover": {
                      bgcolor: alpha(item.tool.color.main, 0.1),
                    },
                  }}
                  secondaryAction={
                    <Stack direction="row" spacing={1}>
                      <CustomTooltip title="View">
                        <IconButton
                          edge="end"
                          onClick={() => handleViewInPopup(item)}
                          sx={{
                            color: item.tool.color.main,
                            "&:hover": {
                              backgroundColor: alpha(item.tool.color.main, 0.1),
                            },
                          }}
                        >
                          <Visibility />
                        </IconButton>
                      </CustomTooltip>
                      <CustomTooltip title="Delete">
                        <IconButton
                          edge="end"
                          onClick={() => handleDeleteSavedContent(item.id)}
                          sx={{
                            color: "#f44336",
                            "&:hover": {
                              backgroundColor: alpha("#f44336", 0.1),
                            },
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </CustomTooltip>
                    </Stack>
                  }
                >
                  <ListItemAvatar>
                    <Avatar sx={{ bgcolor: item.tool.color.main }}>
                      {React.cloneElement(item.tool.icon, {
                        sx: { color: "white" },
                      })}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography variant="subtitle1" fontWeight="600">
                        {item.title}
                      </Typography>
                    }
                    secondary={
                      <>
                        <Typography
                          component="span"
                          variant="body2"
                          color="text.primary"
                        >
                          {item.tool.name}
                        </Typography>
                        <br />
                        <Typography variant="caption" color="text.secondary">
                          {item.timestamp} • {item.content.length} characters
                        </Typography>
                      </>
                    }
                  />
                </ListItem>
              ))}
            </List>
          )}

          {savedContent.length > 0 && (
            <Box sx={{ mt: 3, pt: 3, borderTop: 1, borderColor: "divider" }}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="caption" color="text.secondary">
                  {savedContent.length} saved items
                </Typography>
                <Button
                  size="small"
                  onClick={() => {
                    setSavedContent([]);
                    setSnackbar({
                      open: true,
                      message: "All saved content cleared!",
                      severity: "info",
                    });
                  }}
                  startIcon={<Delete />}
                  sx={{ color: "#f44336" }}
                >
                  Clear All
                </Button>
              </Stack>
            </Box>
          )}
        </Drawer>

        {/* Snackbar for notifications */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          TransitionComponent={Zoom}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackbar.severity}
            sx={{
              borderRadius: 3,
              fontWeight: 700,
              boxShadow: `0 15px 40px ${alpha(currentColor.main, 0.4)}`,
              alignItems: "center",
              width: "auto",
              color: "white",
              background: currentColor.gradient,
              "& .MuiAlert-icon": {
                color: "white",
              },
              "& .MuiAlert-action": {
                color: "white",
              },
            }}
            iconMapping={{
              success: <AutoAwesome />,
              error: <FlashOn />,
              warning: <Lightbulb />,
              info: <SmartToy />,
            }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Container>
    </>
  );
};

export default AIAdvertisingTools;
